// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3_6X7","search":"Settings_search__3RXvh","filter":"Settings_filter__3h7Dk"};